<template>
  <router-link
    v-if="!navItem.navigationItems && navItem.url"
    :key="navItem.header"
    :to="navItem.url"
    :class="[
      'flex w-full items-center gap-x-3 rounded-md p-2 text-left text-sm font-normal leading-6 text-gray-600 hover:rounded-md hover:bg-gray-100'
    ]"
    :aria-current="navItem.header ? 'page' : undefined"
    @click="changeActive()"
  >
    <font-awesome-icon
      v-if="navItem.icon"
      size="lg"
      class="fatshrink-0 w-5 text-gray-400"
      aria-hidden="true"
      :icon="['fal', navItem.icon]"
    />
    {{ navItem.header }}
  </router-link>
  <Disclosure v-else as="div">
    <DisclosureButton
      :class="[
        isOpen ? 'rounded-md' : ' ',
        'flex w-full items-center gap-x-3 p-2 text-left text-sm font-normal leading-6 text-gray-600 hover:rounded-md hover:bg-gray-100'
      ]"
      @click="changeIsOpen()"
    >
      <font-awesome-icon
        v-if="navItem.icon"
        size="lg"
        class="fatshrink-0 w-5 text-gray-400"
        aria-hidden="true"
        :icon="['fal', navItem.icon]"
      />
      {{ navItem.header }}
      <font-awesome-icon
        :class="[
          isOpen ? 'rotate-180' : 'rotate-90',
          'fatshrink-0 ml-auto h-5 w-5 text-gray-400 transition-all'
        ]"
        aria-hidden="true"
        :icon="['fal', 'chevron-up']"
      />
    </DisclosureButton>
    <Transition
      enter-active-class="transition duration-100 ease-out"
      enter-from-class="transform scale-95 opacity-0"
      enter-to-class="transform scale-100 opacity-100"
      leave-active-class="transition duration-75 ease-out"
      leave-from-class="transform scale-100 opacity-100"
      leave-to-class="transform scale-95 opacity-0"
    >
      <DisclosurePanel v-if="isOpen" as="ul" class="'px-2 mt-1" static>
        <li v-for="subItem in navItem.navigationItems" :key="subItem.title" class="transition-all">
          <router-link
            v-if="subItem && subItem.url"
            :key="subItem.title"
            :to="subItem.url"
            :class="[
              subItem.url?.toString() === navStore.currentNavigationUrl
                ? 'font-normal text-brand-500'
                : 'text-gray-600',
              'text-md block rounded-md py-3 pl-14 pr-2 text-sm leading-6 hover:bg-gray-100'
            ]"
            :aria-current="subItem.title ? 'page' : undefined"
            @click="changeActive()"
            >{{ subItem.label }}
          </router-link>
        </li>
      </DisclosurePanel>
    </Transition>
  </Disclosure>
</template>
<script setup lang="ts">
import type { INavigationHeader } from '@/generated-api'
import { useAppStore } from '@/stores/portal-stores/general-stores/app'
import { useNavigationStore } from '@/stores/portal-stores/component-stores/navigation'
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue'

const navStore = useNavigationStore()
const appStore = useAppStore()

// isOpen is to control if the menuitem should be open or not, used for when page refreshes and when redirect from old portal
const isOpen = ref(false)

const props = defineProps<{
  navItem: INavigationHeader
}>()

onBeforeMount(() => {
  if (appStore.content !== undefined) {
    props.navItem.navigationItems?.find((item) => {
      if (item?.url === navStore.currentNavigationUrl) {
        isOpen.value = true
        return
      }
    })
  }
})

function changeActive() {
  navStore.setNavigationIsOpen(false)
}

function changeIsOpen() {
  isOpen.value = !isOpen.value
}
</script>
